import {LABEL_ARTICLE_LIST_GET , LABEL_ARTICLE_LIST_SUCCESS,LABEL_ARTICLE_LIST_FAILURE } from './actions';

const initialState = {
    order: {},
    request:{}
}

export function LabelArticleListReducer(state = initialState, action) {
    
    if(action.type === LABEL_ARTICLE_LIST_GET) {
        return state;
    }
    if(action.type === LABEL_ARTICLE_LIST_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload.res,
                message: 'Success'
            },
            request:action.payload.request
        }
    }
    if(action.type === LABEL_ARTICLE_LIST_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                message: action.payload.message
            },
            request:action.payload.request

        }
    }
    return state;
}

